import React, {Component} from "react";
import { Toast, Modal } from "antd-mobile";
import { withRouter } from 'react-router-dom';
import EnrollServers from '../services/EnrollServers';

// 删除活动确认弹窗：对齐小程序 pages/detail 的 dialog-custom（删除原因 + 验证码校验 + 导出数据备份入口）
class DeleteEnrollDialog extends Component{
    state = {
        code: '',           // 验证码，随机4位数字
        inputCode: '',      // 用户输入的验证码
        finalWord: '',      // 删除原因，会展示给参与者
        buttonClicked: false,
    };
    componentWillReceiveProps(props){
        // 每次打开弹窗重新生成验证码并清空输入，与小程序 deleteEnroll 一致
        if(props.show && !this.props.show){
            this.setState({
                code: Math.random().toString().substring(2, 6),
                inputCode: '',
                finalWord: '',
                buttonClicked: false,
            });
        }
    }
    inputWord = (e) => {
        this.setState({finalWord: e.target.value});
    }
    inputChange = (e) => {
        this.setState({inputCode: e.target.value});
    }
    close = () => {
        this.props.onCancel && this.props.onCancel();
    }
    // 删除之前先导出数据备份
    toExportData = (e) => {
        e.stopPropagation();
        this.close();
        this.props.onExportData && this.props.onExportData();
    }
    deleteOk = () => {
        if(this.state.buttonClicked){
            return;
        }
        let {inputCode, code, finalWord} = this.state;
        if(inputCode != code){
            Toast.fail('请输入正确的验证码');
            return;
        }
        this.setState({buttonClicked: true});
        Toast.loading('正在删除', 0);
        EnrollServers.removeEnroll(finalWord).then((d) => {
            Toast.hide();
            let data = d && d.data;
            if(data && data.sta == 0){
                Toast.success('删除成功', 2);
                this.close();
                setTimeout(() => {
                    // 活动已删除，详情页不可再访问，返回来源页
                    if(window.history.length > 1){
                        this.props.history.goBack();
                    }else{
                        this.props.history.replace('/');
                    }
                }, 1000);
            }else if(data && data.sta == -500){
                // 登录态失效（拦截器已清 token），整页跳转微信授权重新登录
                this.setState({buttonClicked: false});
                Toast.hide();
                React.$wx && React.$wx.webLogin && React.$wx.webLogin();
            }else if(data && data.sta == -1 && data.errcode == -9357){
                // 账号被封禁，需先提交核验
                this.setState({buttonClicked: false});
                Modal.alert('温馨提示', data.msg, [
                    { text: '我知道了', onPress: () => {} },
                    { text: '提交核验', onPress: () => {
                        this.props.history.push('/appeal');
                    }},
                ]);
            }else{
                this.setState({buttonClicked: false});
                Toast.fail((data && data.msg) || '删除失败');
            }
        }).catch(() => {
            Toast.hide();
            this.setState({buttonClicked: false});
            Toast.fail('删除失败');
        });
    }
    render(){
        let { show, status } = this.props;
        let { code, inputCode, finalWord, buttonClicked } = this.state;
        if(!show){
            return null;
        }
        return (
            <div className="delete-enroll-dialog">
                <div className="delete-dialog-mask" onClick={this.close}></div>
                <div className="delete-dialog-body">
                    <div className="delete-dialog-header">删除的活动可在回收站中查看</div>
                    <div className="delete-dialog-content">
                        {
                            status != 2 ?
                            <textarea
                                className="delete-desc"
                                value={finalWord}
                                onChange={this.inputWord}
                                placeholder="请输入删除原因，告知参与者"
                            /> : null
                        }
                        <div className="confirm-input">
                            <input
                                type="number"
                                className="input-code"
                                maxLength={6}
                                value={inputCode}
                                onChange={this.inputChange}
                                placeholder="请输入验证码"
                            />
                            <div className="confirm-code">{code}</div>
                        </div>
                        <div className="delete-title">删除之前可以先<label onClick={this.toExportData}>导出数据</label>备份</div>
                    </div>
                    <div className="delete-dialog-footer">
                        <div className={"btn-item btn-light" + (buttonClicked ? ' btn-disabled' : '')} onClick={this.deleteOk}>确定</div>
                        <div className="btn-item" onClick={this.close}>取消</div>
                    </div>
                </div>
            </div>
        );
    }
}

export default withRouter(DeleteEnrollDialog);
